export default __webpack_public_path__ + "static/media/promotions-pic-2.23e8570b.jpg";